import React, {Component, useRef} from 'react'
//redux
import { connect } from "react-redux";
import { getUserInfoData } from "../User/store/actionCreators";
import { GET_USER_INFO_DATA } from "../User/store/actionTypes";
//样式
import {
    Container
} from "./style";

//组件
import { List, Input, Toast, TextArea,Button } from 'antd-mobile'
import { DatePicker,Picker  } from 'antd-mobile-v2'
import VodUpLoad from "../../components/VodUpLoad";
import ImgUpLoad from "../../components/ImgUpLoad";
import $axios from "../../request";
import {isBlank,checkPhone} from "../../util/StringUtil";


class WagesIJoin extends Component {
    originbodyScrollY = document.getElementsByTagName('body')[0].style.overflowY;
    constructor(props) {
        super(props)
        this.state = {
            imgMaxCount:6,
            //showCalendar:false,
            tagList:[],
            tagVisible:false,
            submitting:false,
            shootingTime:undefined,// 拍摄时间
            shootingPlace:'', // 拍摄地点
            shootingDevice:'', // 拍摄设备
            activityId:'',//活动ID
            tagId:'', // 版块ID
            userId:'', // 用户ID
            userName:'', //用户姓名
            userMobile:'',//用户电话
            mobile:'', //联系电话
            title:'', // 作品标题
            voteTypeEnum:'VIDEO', // 作品类型,VIDEO,IMG
            description:'', // 作品描述
            imgPath:[], // 图片列表
            vodId:'', // 视频id
            companyName:'',// 企业名称
            companyId:'',// 企业id
        }
    }

    componentDidMount() {

        const {userInfo,activity} = this.props;
        let activityId = '';
        let voteTypeEnum = '';
        if(activity&&activity.length>0){
            activityId = activity.id;
            voteTypeEnum = activity.voteTypeEnum?.name;
        }
        this.getTagList()
        this.setState({
            userId:userInfo?.id,
            userName:userInfo?.name,
            userMobile:userInfo?.mobile,
            mobile:userInfo?.mobile,
            companyId:userInfo?.companyId,
            companyName:userInfo?.deptName,
            activityId:activityId,
            voteTypeEnum:voteTypeEnum
        });

    }

    //获取详情
    getTagList =()=> {
        let that = this;
        const {activity} = this.props;
        let url = '/vote/activityTag/list';
        let data = {
            search:[{
                "key": 'activityId',
                "type": 'string',
                "value": activity?.id
            }]
        };

        $axios.postRequest(url, data)
            .then((response) => {
                console.log(url, response);

                if (response.succeed) {
                    let data = response.data;
                   //that.setState({tagList: data});
                    let tagList = [];
                    data.map((item, index) => {
                        tagList.push({
                            label: item.tagName,
                            value: item.id,
                        })
                    });
                    that.setState({tagList: tagList});

                }



            })
            .catch((error) => {
                console.log(url, error);

            });
    }

    onSubmit=()=>{

        const {activity}  = this.props;
        const { activityId,tagId,shootingTime,imgPath,vodId,voteTypeEnum ,userName,userMobile,companyName,description,title,shootingDevice,shootingPlace } = this.state;

        if(!activity){
            Toast.show('当前活动获取失败');
        }else if(activity.voteTypeEnum.name === 'IMG'&&(!imgPath||imgPath.length === 0)){
            Toast.show('请上传图片');
        }else if(activity.voteTypeEnum.name === 'VIDEO'&&isBlank(vodId)){
            Toast.show('请上传视频');
        }else if(isBlank(title)){
           Toast.show('请填写作品名称');
        }else if(isBlank(userName)){
           Toast.show('请填写作者姓名');
        }else if(!checkPhone(userMobile)){
           Toast.show('联系电话有误,请重新填写');
        }else  if(isBlank(companyName)){
            Toast.show('请填写申报单位');
        }else  if(isBlank(tagId)) {
            Toast.show('请选择活动版块');
        }else  if(shootingTime == undefined ||shootingTime == '') {
            Toast.show('请选择拍摄时间');
        }else  if(isBlank(shootingPlace)) {
            Toast.show('请填写拍摄地点');
        }else  if(isBlank(shootingDevice)) {
            Toast.show('请选择拍摄设备');
        }else  if(isBlank(description)) {
            Toast.show('请填写作品描述');
        }else {

            this.submit()
        }
    }
    submit =()=>{
        this.setState({submitting:true});
        const {activity}  = this.props;
        const { companyId,userId,activityId,tagId,shootingTime,imgPath,vodId,voteTypeEnum ,userName,userMobile,companyName,description,title,shootingDevice,shootingPlace } = this.state;
        let that = this;
        let url = '/vote/creation/add';
        let data = {
            activityId:activity.id,
            tagId:tagId[0],
            shootingTime:shootingTime,
            imgPath:imgPath,
            vodId:vodId,
            voteTypeEnum:activity.voteTypeEnum.name,
            userName:userName,
            userMobile:userMobile,
            mobile:userMobile,
            userId:userId,
            companyName:companyName,
            companyId:companyId,
            description:description,
            title:title,
            shootingDevice:shootingDevice,
            shootingPlace:shootingPlace,
            verifyEnum:'VERFYING',
            sourceTypeEnum:'H5'
        };

        $axios.postRequest(url, data)
            .then((response) => {
                console.log(url, response);

                if (response.succeed) {
                   // let data = response.data;
                    this.handleFun('/submitSucceed');

                }



            })
            .catch((error) => {
                console.log(url, error);

            });
    }

    handleFun(to) {
        to+='?&time='+Date.parse(new Date())
        this.props.history.push(to)
    }



    render() {
        let { submitting,tagVisible,tagList,tagId,shootingTime,imgPath,vodId,voteTypeEnum ,userName,userMobile,companyName,description,title,shootingDevice,shootingPlace } = this.state
        let { userInfo,activity} = this.props;

        let allowUpload;
        let submitText;
        const now = new Date();
        if(now < activity.subStartTime){
            allowUpload = false;
            submitText = '投稿未开始';
        } else if(activity.subEndTime<now){
            allowUpload = false;
            submitText = '投稿已结束';
        }else{
            allowUpload = true;
            submitText = '提交';
        }


        return (
            <Container>
                <div className="container">

                    {
                        activity.voteTypeEnum?.name ==='VIDEO'&&<div className="vodUpLoad">
                            <div className="vodUpLoad2">
                                <VodUpLoad
                                    vid={vodId}
                                    parent={(data) => {
                                        this.setState({ vodId: data }) }}
                                />
                                <div className="uploadText">上传视频</div>
                            </div>
                            <div className="uploadText">请上传MP4格式的视频,视频大小不能超过500M</div>
                        </div>
                    }
                    {
                        activity.voteTypeEnum?.name ==='IMG'&&<div className='imgUpLoad'>

                                <ImgUpLoad
                                    imgMaxCount={8}
                                    imgList={imgPath}
                                    parent={(data) => {
                                               this.setState({ imgPath: data }) }}
                                />

                                {/*<VodUpLoad*/}
                                {/*    vid={vid}*/}
                                {/*    parent={(data) => {*/}
                                {/*        this.setState({ vid: data }) }}*/}
                                {/*/>*/}
                                {/*<div className="uploadText">上传图片</div>*/}

                            <div className="uploadText">请上传2M以上的图片,最多可上传8张</div>
                        </div>
                    }

                    <div className="marginTop16 form">
                        <List
                            // style={{
                            //     '--prefix-width': '6em',
                            // }}
                        >

                            <List.Item title='作品名称'>
                                <Input className='listItem' placeholder='请输入作品名称' clearable maxLength={20} value={title} onChange={(data) =>{this.setState({title:data})}}/>
                            </List.Item>
                            <List.Item title='作者姓名'>
                                <Input className='listItem' placeholder='请输入作者姓名' clearable  maxLength={20} value={userName} onChange={(data) =>{this.setState({userName:data})}}/>
                            </List.Item>
                            <List.Item title='作者联系电话'>
                                <Input className='listItem' placeholder='请输入作者联系电话' clearable maxLength={11} type="tel"  value={userMobile} onChange={(data) =>{this.setState({userMobile:data})}}/>
                            </List.Item>
                            <List.Item title='申报单位'>
                                <Input className='listItem' placeholder='请输入所在单位全称' clearable  maxLength={64} value={companyName} onChange={(data) =>{this.setState({companyName:data})}}/>
                            </List.Item>

                            <Picker
                                title={'活动板块'}
                                data={tagList}
                                value={this.state.tagId}
                                cols={1}
                                onChange={(val) => {
                                    this.setState({tagId:val})
                                }}
                            >
                                <List.Item className='listItem'  title='活动板块'></List.Item>
                            </Picker>

                            <DatePicker
                                mode={'date'}
                                title={'拍摄时间'}
                                value={shootingTime}
                                maxDate={new Date()}
                                format={'YYYY-MM-DD'}
                                onChange={(val) => {this.setState({shootingTime:val})}}
                            >
                                <List.Item className='listItem' title='拍摄时间' value={shootingTime} ></List.Item>
                            </DatePicker>

                            <List.Item title='拍摄地点'>
                                <Input className='listItem' placeholder='请输入拍摄地点' clearable  maxLength={20} value={shootingPlace} onChange={(data) =>{this.setState({shootingPlace:data})}}/>
                            </List.Item>
                            <List.Item title='拍摄设备'>
                                <Input className='listItem' placeholder='请输入拍摄设备' clearable  maxLength={20} value={shootingDevice} onChange={(data) =>{this.setState({shootingDevice:data})}}/>
                            </List.Item>

                            <List.Item title='作品描述'>
                                <TextArea
                                    className='listItem'
                                    showCount
                                    maxLength={255}
                                    placeholder='请输入作品描述'
                                    autoSize={{ minRows: 3, maxRows: 10 }}
                                    value={description}
                                    onChange={(data) =>{this.setState({description:data})}}
                                />
                            </List.Item>
                            <List.Item >
                                <Button
                                    loading={submitting}
                                    disabled={!allowUpload}
                                    loadingText={'提交中'}
                                    block color='primary' size='large'
                                        onClick={() => {
                                            this.onSubmit()
                                        }}
                                >
                                    {submitText}
                                </Button>
                            </List.Item>
                        </List>

                    </div>
                </div>






            </Container>
        )
    }
}

const mapState = state => {

    return {
        userInfo:state.getIn(['user', 'userInfo']),
        activity:state.getIn(['activity', 'activitySelect'])
    }

}
const mapDispatch = dispatch => {
    return {

        _getUserInfoData(data) {

            dispatch(getUserInfoData(data))
        }
    }
}

export default connect(mapState, mapDispatch)(WagesIJoin)
